module.exports = __webpack_public_path__ + "img/icb-co-elite-m@3x.691dc652.png";